import classNames from "classnames";
import { ElementType, ReactNode } from "react";
import "./index.scss";

type TypographySize = "xs" | "sm" | "md" | "lg" | "xl";
type TypographyWeight = "light" | "regular" | "medium" | "semibold" | "bold";

interface PDLTypographyProps {
  as?: ElementType | null;
  className?: string | null;
  children?: ReactNode | null;
  display?: boolean;
  lower?: boolean;
  size?: TypographySize;
  upper?: boolean;
  variant?: string | null;
  weight?: TypographyWeight;
}

const PDLTypography = ({
  as = null,
  className = null,
  children = null,
  display = false,
  lower = false,
  size = "xs",
  upper = false,
  variant = null,
  weight = "regular",
}: PDLTypographyProps) => {
  const Component: ElementType = as ?? (display ? "h1" : "p");

  const typographyClassname = classNames(
    "pdl_dna_typography",
    { display },
    className,
    lower && "lower",
    size,
    upper && "upper",
    variant,
    weight
  );

  return <Component className={typographyClassname}>{children}</Component>;
};

export default PDLTypography;
